import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import RoutePage from './routes/route';
import './scss/style.scss';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import 'react-responsive-modal/styles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//widgets
import SvgComp from './widget/w-svg';



const CloseButton = ({ closeToast }) => (
  <div className='d-flex align-items-center'>
  <SvgComp
  SvgId={'Close'}
  svgClass='icon-size t-p-75 cursor-pointer'
  handleImageClick={closeToast}
  tooltipId='close'
  tooltipPosition='none'
  tooltipText='Close Button'
  svgtabIndex={0}
  />
  </div>
);




ReactDOM.render(
  <Provider store={store}>
     <ToastContainer
  className='toaster' 
  limit={3}
  role='alert' 
  position='top-right'
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={true}
  closeOnClick={false}
  closeButton={CloseButton}
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme='colored'/>
  
    
      <RoutePage />
  </Provider>,
  document.getElementById('root')
);
